const KakaoMapCroodsPlugin = {};

const width = 500;
const height = 500;

// var zoneCode, sigunguCode;
var addr, lat, har;

KakaoMapCroodsPlugin.install = function (Vue) {

    Vue.prototype.$_openKakaoPostApi = function() {
        
        new window.daum.Postcode({
            width: width,
            height: height,
            oncomplete: (data) => {
                // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                // 도로명 주소의 노출 규칙에 따라 주소를 조합한다.
                // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                let fullRoadAddr = data.roadAddress; // 도로명 주소 변수
                let extraRoadAddr = ''; // 도로명 조합형 주소 변수

                // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                    extraRoadAddr += data.bname;
                }
                // 건물명이 있고, 공동주택일 경우 추가한다.
                if (data.buildingName !== '' && data.apartment === 'Y') {
                    extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data
                    .buildingName);
                }
                // 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                if (extraRoadAddr !== '') {
                    extraRoadAddr = ' (' + extraRoadAddr + ')';
                }
                // 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다.
                if (fullRoadAddr !== '') {
                    fullRoadAddr += extraRoadAddr;
                }
                
                // 우편번호와 주소 정보를 해당 필드에 넣는다.
                // zoneCode = data.zonecode; //5자리 새우편번호 사용
                // sigunguCode = data.sigunguCode;

                addr = fullRoadAddr;
                this.$_setCoords();
            }
        }).open({
            left: (window.screen.width / 2) - (width / 2),
            top: (window.screen.height / 2) - (height / 2)
        });

    }

    Vue.prototype.$_setCoords = function() {
        
        var self = this;
        var geocoder = new window.kakao.maps.services.Geocoder();

        geocoder.addressSearch(addr, function (result, status) {
            // 정상적으로 검색이 완료됐으면 
            if (status === window.kakao.maps.services.Status.OK) {
                
                lat = self.$_toFixed(result[0].y, 5);
                har = self.$_toFixed(result[0].x, 5);

                self.$_setVuexBookingWrite();
            }
        });
    }

    Vue.prototype.$_setVuexBookingWrite = function() {
        this.$store.state.booking.itemWrite.lat = lat;
        this.$store.state.booking.itemWrite.har = har;
        this.$store.state.booking.itemWrite.addr = addr;
    }
}

export default KakaoMapCroodsPlugin;